/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { FactorOptions } from './FactorOptions';
import {
    FactorOptionsFromJSON,
    FactorOptionsFromJSONTyped,
    FactorOptionsToJSON,
} from './FactorOptions';

/**
 * 
 * @export
 * @interface Factor
 */
export interface Factor {
    /**
     * 
     * @type {FactorMethod}
     * @memberof Factor
     */
    method?: FactorMethod;
    /**
     * 
     * @type {FactorOptions}
     * @memberof Factor
     */
    options?: FactorOptions;
}

/**
 * Check if a given object implements the Factor interface.
 */
export function instanceOfFactor(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FactorFromJSON(json: any): Factor {
    return FactorFromJSONTyped(json, false);
}

export function FactorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Factor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': !exists(json, 'method') ? undefined : FactorMethodFromJSON(json['method']),
        'options': !exists(json, 'options') ? undefined : FactorOptionsFromJSON(json['options']),
    };
}

export function FactorToJSON(value?: Factor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': FactorMethodToJSON(value.method),
        'options': FactorOptionsToJSON(value.options),
    };
}

